import $http from './http'
import config from './config'

export default {
    name: 'bill',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    cashier(data) {
        return $http.post(this.getUrl(`/trade/cashier`), data);
    },
    redirect(data) {
        return $http.post(this.getUrl(`/trade/redirect`), data);
    },
}



// WEBPACK FOOTER //
// ./src/apis/tradeApis.js